import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';

// Components
import Item from '../../../../../../../../components/Item';

class Results extends Component {

  constructor(props){
    super(props);

    this.state = {
      data :[
        { "image":"http://www.lrcsolutions.com/images/175/175-1.jpeg","oar": 10, "username": "22GEmnEYE007", "id": 175, "age": "37", "city": "De Soto, KS", "ClrTxt": null, "priority": "WAITING", "DscID": 3, "All3": "5'8\"\r\nSlender\r\nSexy\r\n" },
        { "image":"http://www.lrcsolutions.com/images/18160/18160-01.jpeg","oar": 10, "username": "ann2015", "id": 18160, "age": "37", "city": "Kansas, KS", "ClrTxt": null, "priority": "WAITING", "DscID": 3, "All3": "5'5\"\r\nAthletic & Toned\r\n?\r\nSexy\r\nHorses" },
        { "image":"http://www.lrcsolutions.com/images/19437/19437-01.jpeg","oar": 10, "username": "B1981M", "id": 19437, "age": "35", "city": "Kansas, KS", "ClrTxt": null, "priority": "WAITING", "DscID": 3, "All3": "5'4\"\r\nFew Ex\r\n?\r\n" },
        { "image":"http://www.lrcsolutions.com/images/16128/16128-01.jpeg","oar": 10, "username": "Bry813", "id": 16128, "age": "36", "city": "Kansas, Missouri", "ClrTxt": null, "priority": "WAITING", "DscID": 3, "All3": "5'6\"\r\nAthletic & Toned\r\nSexy, Tatoos\r\n"},
        { "image":"http://www.lrcsolutions.com/images/3643/3643-2.jpeg","oar": 10, "username": "KA21", "id": 3643, "age": "35", "city": "Kansas, MO", "ClrTxt": null, "priority": "WAITING", "DscID": 3, "All3": "5'6\"\r\nAverage\r\nNBS\r\n?\r\n" },
        { "image":"http://www.lrcsolutions.com/images/12668/12668-01.2.jpg","oar": 10, "username": "kansasangel81", "id": 12668, "age": "36", "city": "Osa, Kansas", "ClrTxt": null, "priority": "WAITING", "DscID": 3, "All3": "5'8\"\r\nSlender\r\n1 pic\r\nTall\r\n" },
        { "image":"http://www.lrcsolutions.com/images/18574/18574-01.jpg","oar": 10, "username": "ShamelesslySassy", "id": 18574, "age": "37", "city": "Odessa, MO", "ClrTxt": null, "priority": "WAITING", "DscID": 3, "All3": "5'6\"\r\nSlender\r\n" },
        { "image":"http://www.lrcsolutions.com/images/287/287-01.jpg","oar": 10, "username": "Soccermomofone5", "id": 287, "age": "36", "city": "Olathe, KS", "ClrTxt": null, "priority": "WAITING", "DscID": 3, "All3": "5'2\"\r\n" },
        { "image":"http://www.lrcsolutions.com/images/18247/18247-01.jpg","oar": 10, "username": "SuperNice", "id": 18247, "age": "36", "city": "Lawrence, KS", "ClrTxt": null, "priority": "WAITING", "DscID": 3, "All3": "5'11\"\r\n" },
        { "image":"http://www.lrcsolutions.com/images/15593/15593-01.jpg","oar": 10, "username": "susieq816", "id": 15593, "age": "37", "city": "Kansas, MS", "ClrTxt": null, "priority": "WAITING", "DscID": 3, "All3": "5'8\"\r\nAverage\r\nNBS\r\n1 pic\r\n" },
      ],
    };
  }

  render(){
    const { classes, theme, location } = this.props;
    return(
      <div className={classes.items}>
        {this.state.data.map(function(profile, index){
          return <Item data={profile}/>;
        })}
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
    };
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps)(Results)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/CreateNewSearch/scenes/SixBasicFilters/scenes/Results/index.js